import {addClass, removeClass} from "../_vars";

export const portfolioSort = () => {
   const createItemImages = document.getElementsByClassName("create-item__image");

   function handleMediaLoading() {
      [...createItemImages].forEach(item => {
         const image = item.querySelector("img");
         const video = item.querySelector("video");
         let isLoaded = function () {
            if (video) video.classList.contains("--loaded");
         }
         if (isLoaded()) return;
         if (!image || !video) return;

         function loadVideo() {
            if (video.hasAttribute("data-src")) {
               const src = video.getAttribute("data-src");
               if (!src) return;

               video.setAttribute("src", src);
            } else {
               const sourceItems = video.querySelectorAll("source");
               sourceItems.forEach(sourceItem => {
                  const src = sourceItem.getAttribute("data-src");
                  if (!sourceItem) return;

                  sourceItem.setAttribute("src", src);
               });
            }
            video.classList.add("--loaded");
            video.load();
            video.style.opacity = "1";
         }
         image.addEventListener("load", loadVideo);
         if (image.classList.contains("ewww_webp_loaded")) loadVideo();
         setTimeout(() => {
            if (isLoaded()) return;
            loadVideo();
         }, 2000);
      });
   }
   handleMediaLoading();

   const portfolioSection = document.querySelector(".cases__grid");
   if (!portfolioSection) return;

   const proudSwitchersParent = document.querySelector(".proud__switchers");
   const proudSwitchers = document.querySelectorAll(".proud__switcher");
   const casesSwitchersParent = document.querySelector(".cases__switchers-inner");
   const casesSwitchers = document.querySelectorAll(".cases__switcher");

   function handleMutations(mutationsList, observer) {
      mutationsList.forEach((mutation) => {
         if (mutation.type === 'childList') {
            handleMediaLoading();
         }
      });
   }
   const observer = new MutationObserver(handleMutations);
   observer.observe(portfolioSection, {childList: true});

   if (proudSwitchersParent) {
      proudSwitchersParent.addEventListener("click", (e) => {
         const {target} = e;
         if (!target.classList.contains("proud__switcher")) return;
         if (target.classList.contains("--active")) return;

         proudSwitchers.forEach((s) => removeClass(s, "--active"));
         casesSwitchers.forEach((s) => removeClass(s, "--select"));

         addClass(target, "--active");
      });

      casesSwitchersParent.addEventListener("click", (e) => {
         const {target} = e;
         if (!target.classList.contains("cases__switcher")) return;
         if (target.classList.contains("--select")) return;

         casesSwitchers.forEach((s) => removeClass(s, "--select"));
      });
   }
};
